import React from "react"

import { colors } from "@bullseye/tailwind-config"

import { IconProps } from "./IconProps"

const SmartphoneIcon: React.FC<IconProps & { isLoading?: boolean }> = ({
  scale = 1,
  lineScale = 1,
  color = colors.gray[950],
  ...rest
}) => (
  <svg
    width={scale * 24}
    height={scale * 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Smartphone"
    {...rest}
  >
    <path
      d="M17 2H7C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2Z"
      stroke={color}
      strokeWidth={lineScale * 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 18H12.01"
      stroke={color}
      strokeWidth={lineScale * 2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SmartphoneIcon
